// TODO: TBD use MUI validation or custom
import React, { useContext, useState } from 'react';
import { Auth } from 'aws-amplify';
import { useTranslation } from 'react-i18next';
import { Typography, Box, Grid, Container, Link } from '@mui/material';
import { di } from '../../state/inversify.config';
import { LoginDomainService } from '../login/loginDomainService';
import { checkPasswordStrength } from '../login/components/validation.helper';
import { UserNotificationContext } from '../../components/userNotification/userNotificationContext';
import { UserNotificationType } from '../../components/userNotification/userNotificationType.enum';
import { TextInput } from '../../components/textInput/textInput';
import { PasswordTextInput } from '../../components/passwordTextInput/passwordTextInput';
import { PasswordGuidelines } from '../signUp/passwordGuidelines';
import { Button } from '../../components/button/button';
import { Spinner } from '../../components/spinner/spinner';

interface ResetPasswordProps {
  email: string;
}
export function ResetPassword({ email }: ResetPasswordProps) {
  const { t } = useTranslation();

  const { addUserNotification } = useContext(UserNotificationContext);

  const loginDomainService = di.get<LoginDomainService>(LoginDomainService);

  const [isLoading, setIsLoading] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState(false);
  const [inputs, setInputs] = useState({
    newPassword: '',
    confirmNewPassword: '',
    verificationCode: '',
  });

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name === 'newPassword') {
      setShowPasswordError(true);
      const validPassword = checkPasswordStrength(value);
      if (validPassword) {
        setShowPasswordError(false);
      }
    }
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const resetPassword = () => {
    if (inputs.newPassword !== inputs.confirmNewPassword) {
      addUserNotification(
        UserNotificationType.ERROR,
        t('auth.PASSWORD_NO_MATCH').toString(),
        UserNotificationType.ERROR,
      );
      return;
    }
    setIsLoading(true);
    Auth.forgotPasswordSubmit(
      email.trim(),
      inputs.verificationCode.trim(),
      inputs.newPassword.trim(),
    )
      .then(() => {
        loginDomainService.dispatchLogin({
          email,
          password: inputs.newPassword,
        });
      })
      .catch((err) => {
        setIsLoading(false);
        addUserNotification(
          UserNotificationType.ERROR,
          err.message,
          UserNotificationType.ERROR,
        );
      });
  };

  return (
    <Container>
      {isLoading ? (
        <Grid
          container
          spacing={16}
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <Spinner open={isLoading} text={t('SIGNING_IN') || ''} />
        </Grid>
      ) : (
        <Box>
          <Typography component="h1" variant="h4" sx={{ textAlign: 'center' }}>
            {t('CHECK_YOUR_EMAIL')}
          </Typography>
          <p>{t('CONFIRMATION_CODE_SENT')}</p>
          <TextInput
            type="number"
            label={t('VERIFICATION_CODE')}
            name="verificationCode"
            autoFocus
            fullWidth
            required
            onChange={handleInputChange}
            value={inputs.verificationCode}
          />
          <PasswordTextInput
            label={t('NEW_PASSWORD')}
            name="newPassword"
            fullWidth
            required
            onChange={handleInputChange}
            value={inputs.newPassword}
          />
          <PasswordTextInput
            label={t('CONFIRM_NEW_PASSWORD')}
            name="confirmNewPassword"
            autoComplete="new-password"
            fullWidth
            required
            onChange={handleInputChange}
            value={inputs.confirmNewPassword}
          />
          <PasswordGuidelines showPasswordError={showPasswordError} />
          <Grid textAlign="center" sx={{ mt: 2, mb: 1 }}>
            <Button
              color="secondary"
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={resetPassword}
              label={t('common.generic.GENERIC_NAVIGATION_NEXT').toString()}
            />
            <Link href="/">{t('SIGN_IN')}</Link>
          </Grid>
        </Box>
      )}
    </Container>
  );
}
